import PropTypes from 'prop-types';
import { ThreeCircles } from 'react-loader-spinner';
import { useTheme, styled } from '@mui/material';
import ProgressBar from './ProgressBar';

const RootStyle = styled('div')(({ theme }) => ({
	right: 0,
	bottom: 0,
	zIndex: 99999,
	width: '100%',
	height: '100%',
	position: 'fixed',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: theme.palette.background.default,
}));

LoadingScreen.propTypes = {
	isDashboard: PropTypes.bool,
};

export default function LoadingScreen({ isDashboard, ...other }) {
	const theme = useTheme();

	return (
		<>
			<ProgressBar />

			{!isDashboard && (
				<RootStyle {...other}>
					<ThreeCircles
						height="100"
						width="100"
						color={theme.palette.primary.main}
						wrapperStyle={{}}
						wrapperClass=""
						visible
						ariaLabel="three-circles-rotating"
						outerCircleColor=""
						innerCircleColor=""
						middleCircleColor=""
					/>
				</RootStyle>
			)}
		</>
	);
}
